import { render, staticRenderFns } from "./SectorEditDialog.vue?vue&type=template&id=3fbbe9b8&scoped=true"
import script from "./SectorEditDialog.vue?vue&type=script&lang=js"
export * from "./SectorEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbe9b8",
  null
  
)

export default component.exports